//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { czHomePath } from '~/constant/cz';
name: 'CZhead2';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['user', 'identities']),
  },
  methods: {
    goHome() {
      this.$router.push(czHomePath);
    },
  },
};
